import {Util} from 'yougile-util'
import {DataObjectId, getStickerType, Hub} from 'yougile-model'
import {SharedBoardsClient} from '@client/shared-boards-client'
import {Sync} from '@client/sync'
import {Backend} from '@common/backend'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {getTemplate} from '@components/movement-templates/helpers/get-template'
import {ChatSubscribers} from '@extensions/chat-subscribers'
import {Sticker} from '@extensions/sticker/sticker'
import {Task} from '@extensions/task'
import {recreateSubtasks} from './recreate-subtasks'
import {refreshStickers} from './refresh-stickers'
import {RequiredSticker} from './types'

export const createTask = ({
  text,
  stickers,
  columnId,
  toEnd,
  templateId
}: {
  text: string
  stickers: RequiredSticker[]
  columnId?: DataObjectId
  toEnd?: boolean
  templateId?: DataObjectId
}): DataObjectId | undefined => {
  if (!text || !columnId) {
    return undefined
  }

  const newTask = Task.createTask(text, {
    location: columnId,
    allowApi: true,
    companyId: Sync.getCurrentSandbox().companyId,
    resolveNameConflicts: true,
    toEnd
  })
  if (!newTask) {
    return undefined
  }

  void Tracking.send(TrackingEvent.taskCreate)

  updateTaskWithDefaultStickerValues(newTask, stickers)

  if (!SharedBoardsClient.getId()) {
    Task.pinFilters(newTask, 'create-task')
  }

  Sticker.createTaskHook(newTask)

  if (templateId) {
    const template = getTemplate(templateId)
    if (template && !template.deleted) {
      const usersToSubs = template?.data?.taskTemplate?.subscribeUsers || []

      for (let index = 0; index < usersToSubs.length; index++) {
        const uid = usersToSubs[index]
        const needCommit = index === usersToSubs.length - 1

        uid && ChatSubscribers.setSubscription(uid, newTask, true, needCommit)
      }
    }

    newTask.data ??= {}
    newTask.data.checklists = Util.clone(template?.data.checklists || [])
    newTask.data.subtaskList = Util.clone(template?.data.subtaskList)
    refreshStickers(newTask)

    recreateSubtasks(newTask)

    newTask.data.createdByTemplateId = templateId
    newTask.description = template?.description || ''

    newTask.commit()
  }

  return newTask.id
}

const updateTaskWithDefaultStickerValues = (
  task: Hub,
  stickers: RequiredSticker[]
): void => {
  for (const sticker of stickers) {
    if (!task.stickers) {
      task.stickers = {}
    }
    const state = Util.clone(sticker.defaultState)
    if (getStickerType(sticker.tag) === 'user' && Array.isArray(state)) {
      const authorId = state.indexOf('author')
      if (authorId >= 0) {
        state[authorId] = Backend.loadId()
      }
    }
    task.stickers[sticker.tag.id] = state || ''
  }

  task.commit()
}
